/* src/app/components/processing/platform-activity/servers-table/servers-table.component.scss */
.hover-1-before--medium:before,
.hover-1-before--light:before {
  position: var(--position, absolute);
  top: var(--top, 0);
  right: var(--right, 0);
  bottom: var(--bottom, 0);
  left: var(--left, 0);
}
.hover-1-before--medium:hover:before,
.hover-1-before--light:hover:before {
  background-color: var(--background-color, inherit) !important;
  opacity: var(--opacity, inherit) !important;
}
:not(.dark-theme) .hover-1-before--medium:hover:before,
:not(.dark-theme) .hover-1-before--light:hover:before {
  --background-color: #000;
}
.dark-theme .hover-1-before--medium:hover:before,
.dark-theme .hover-1-before--light:hover:before {
  --background-color: white;
}
:not(.dark-theme) .hover-1-before--light:hover:before {
  --opacity: 0.04;
}
.dark-theme .hover-1-before--light:hover:before {
  --opacity: 0.08;
}
:not(.dark-theme) .hover-1-before--medium:hover:before {
  --opacity: 0.05;
}
.dark-theme .hover-1-before--medium:hover:before {
  --opacity: 0.08;
}
.hover-1 {
  transition: var(--transition, background 0.2s ease);
}
:not(.dark-theme) .hover-1--lighter {
  background-color: rgba(0, 0, 0, 0.02);
}
.dark-theme .hover-1--lighter {
  background-color: rgba(255, 255, 255, 0.04);
}
:not(.dark-theme) .hover-1--light {
  background-color: rgba(0, 0, 0, 0.04);
}
.dark-theme .hover-1--light {
  background-color: rgba(255, 255, 255, 0.08);
}
:not(.dark-theme) .hover-1--medium {
  background-color: rgba(0, 0, 0, 0.05);
}
.dark-theme .hover-1--medium {
  background-color: rgba(255, 255, 255, 0.08);
}
.hover-1-before--medium:before,
.hover-1-before--light:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: transparent;
  transition: var(--transition, background 0.2s ease);
}
.no-hover:hover {
  background: transparent !important;
  background-color: transparent !important;
}
.no-hover:hover:before {
  display: none !important;
}
.no-persistent-ripple-button .mat-mdc-button-persistent-ripple {
  display: none !important;
}
.mat-mdc-option .mat-pseudo-checkbox-minimal {
  display: none;
}
.mat-elevation-2 {
  box-shadow:
    0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14),
    0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.mat-elevation-8 {
  box-shadow:
    0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14),
    0px 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lex-theme-font--black-white {
  color: #000 !important;
}
.dark-theme .lex-theme-font--black-white {
  color: #fff !important;
}
.lex-theme-font--classic {
  color: var(--text-color) !important;
}
.dark-theme .lex-theme-font--classic {
  color: var(--text-color) !important;
}
.lex-theme-font--softer {
  color: var(--text-color-3) !important;
}
.dark-theme .lex-theme-font--softer {
  color: var(--text-color-5) !important;
}
.darker-font {
  color: #000;
}
.dark-theme .darker-font {
  color: #fff;
}
.darker-font--all * {
  color: #000;
}
.dark-theme .darker-font--all * {
  color: #fff;
}
.lighter-font {
  color: var(--text-color);
}
.dark-theme .lighter-font {
  color: var(--text-color);
}
.lighter-font--all * {
  color: var(--text-color);
}
.dark-theme .lighter-font--all * {
  color: var(--text-color);
}
.font-size-11px {
  font-size: 11px;
}
.font-size-12px {
  font-size: 12px;
}
.font-size-13px {
  font-size: 13px;
}
.font-size-14px {
  font-size: 14px;
}
.font-size-16px {
  font-size: 16px;
}
.full-page-body-height,
.front-and-center--use-vh-unit {
  height: calc(100vh - 81px);
}
.front-and-center,
.front-and-center--use-vh-unit {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}
.mat-css-card {
  background-color: var(--background-card);
  border-radius: 7px;
  overflow: visible !important;
  height: fit-content;
  width: 70%;
  min-height: 70%;
  min-width: 280px;
  max-width: 500px;
  position: relative;
  border-radius: 40px;
}
.mat-css-card .css-card-header,
.mat-css-card .css-card-content,
.mat-css-card .css-card-footer {
  display: flex;
  justify-content: center;
  padding: 0 20px 5px;
  width: calc(100% - 40px);
  max-width: 500px;
}
.mat-css-card .css-card-header {
  background-color: #797d95;
  color: var(--header-font-color, #fff);
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  height: 40%;
  padding: 2px 20px 8px 18px;
  width: calc(100% - 38px);
  align-items: center;
  justify-content: flex-start;
}
.mat-css-card .css-card-content {
  padding: 0;
  margin: 0;
  color: var(--card-body-font-color, #fff);
  align-items: flex-start;
  justify-content: center;
}
.mat-css-card .css-card-footer:has(button) {
  margin-top: 10px;
  padding-bottom: 8px;
  justify-content: center;
  flex-grow: 1;
  flex-shrink: 1;
  align-items: center;
  flex-direction: column;
}
.dark-theme .mat-css-card .css-card-footer:has(button) button {
  width: 95%;
}
.dark-theme .mat-css-card .css-card-footer:has(button) button i {
  --fa-primary-color: rgb(237, 184, 80);
  --fa-secondary-color: #b4a596;
}
.dark-theme .mat-css-card .css-card-footer:has(button) button b {
  color: rgb(237, 184, 80) !important;
}
.mat-css-card:before {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  left: 0;
  bottom: 0;
  transform-origin: center;
  background-color: var(--background-card);
  transform: scale(1) rotateZ(29deg) translate3d(14px, 42px, 0px);
}
.triangle,
.mat-css-card:before {
  border-left: 50px solid var(--background-card);
  border-right: 50px solid transparent;
  border-top: 50px solid transparent;
  border-bottom: 50px solid transparent;
  background: transparent;
}
.dark-theme .mat-css-card .css-card-header {
  --palette-primary-default: rgb(17, 14, 0);
  --header-font-color: rgb(237, 184, 80);
}
.dark-theme .mat-css-card .css-card-content {
  --card-body-font-color: #b4a596;
}
:host {
  height: 100%;
}
.mat-mdc-header-row > td {
  padding-bottom: 10em;
}
td {
  background: #FFF;
  font-size: 16px;
  color: #000;
  border: 0;
  height: 55px;
}
td.mat-mdc-cell {
  border: none;
}
.mat-mdc-table .mat-mdc-header-cell,
.mat-mdc-table .mat-sort-header {
  background: transparent;
  font-size: 16px;
  --sort-header-color: #000;
  border-bottom: 2px solid #FFC107;
}
.mat-mdc-row {
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.25);
}
tr td:first-child {
  border-left: 2px solid #223F92;
}
.old-ping {
  color: red;
}
.fa-play {
  color: #1e6500;
}
.action-button .fa-play {
  color: inherit;
}
:host-context(.dark-theme) th {
  border-bottom: 1px solid #d4a20e;
}
:host-context(.dark-theme) tr:first-child {
  border-left: 2px solid #345bcc;
}
:host-context(.dark-theme) td {
  background-color: #363636;
}
:host-context(.dark-theme) .fa-play {
  color: #45b549;
}
:host-context(.dark-theme) .action-button .fa-play {
  color: inherit;
}
:host-context(.dark-theme) .old-ping {
  color: #ff7272;
}
/*# sourceMappingURL=servers-table.component.css.map */
